// extracted by mini-css-extract-plugin
module.exports = {"container":"TagGroup_container__18xUr","title":"TagGroup_title__22V5p","tagcontainer":"TagGroup_tagcontainer__39Juw","tag":"TagGroup_tag__1HozR"};